// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer-module__footer___3QjQW","legendImage":"footer-module__legendImage___VEXqs","legend":"footer-module__legend___1zPUk","warning":"footer-module__warning___1Y570"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.module.scss
// module id = 338
// module chunks = 0